import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FeatureDetail, FeatureGroupKey, Product, ProductName } from "@zp-models/product";
import { ProductService } from "@zp-services/product.service";

@Component({
  selector: "app-product-comparison",
  imports: [CommonModule, TranslateModule],
  templateUrl: "./product-comparison.component.html",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductComparisonComponent {
  @Input() isMobileView: boolean;
  @Input() allProducts: Product[] = [];
  @Input() advicedProduct: Product;
  @Input() featureGroups: FeatureGroupKey[] = [];
  @Output() orderProduct = new EventEmitter<ProductName>();

  selectedProductIndex = 0;
  products: Product[] = [];

  constructor(private productService: ProductService) {}

  ngOnInit(): void {
    this.products = this.productService.getProducts();
    this.selectedProductIndex = this.products.findIndex(
      (product) => product.name === this.advicedProduct.name
    );
    this.onSelectProduct(this.selectedProductIndex);
  }

  onSelectProduct(index: number) {
    this.selectedProductIndex = index;
  }

  getProductNames(): ProductName[] {
    return this.allProducts.map((product) => product.name);
  }

  getFeatureKeys(group: FeatureGroupKey): string[] {
    const featureBlock = this.allProducts[0]?.features[group];
    if (!featureBlock) return [];

    return Object.keys(featureBlock);
  }

  getFeatureKeysForMobile(group: FeatureGroupKey, product: Product): string[] {
    return Object.keys(product.features[group] ?? {});
  }

  getFeatureMetadata(group: FeatureGroupKey, key: string): FeatureDetail | undefined {
    return this.allProducts[0]?.features[group]?.[key] ?? this.products[0]?.features[group]?.[key];
  }
}
